export default "__VITE_ASSET__B7BeIw5K__"